import React from "react";
import "../../commoncss/Login.css";
import { useState } from "react";
import { FaEyeSlash, FaEye } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { useToast } from "../../commoncomponents/ToastProvider";
import Loader from "../../commoncomponents/Loader";
import AnimatedBackground from "../../commoncomponents/AnimatedBackground";

function AgentLogin() {
  const [password, showPassword] = useState(false);
  const { showToast } = useToast();
  const [loadingAnimation, setLoadingAnimation] = useState(false);
  const [getLogin, setLogin] = useState({});
  const navigate = useNavigate();
  const toggleIcon = () => {
    showPassword((prevState) => !prevState);
  };
  const handleLogin = async () => {
    if (!getLogin.email || !getLogin.password) {
      showToast("All fields are reqiored", "error");
    }
    setLoadingAnimation(true);
    try {
      const resp = await fetch(`${process.env.REACT_APP_URL}/agent/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
        body: JSON.stringify(getLogin),
      });
      const dataset = await resp.json();
      console.log(dataset);
      if (resp.status === 200) {
        if (dataset.status === true) {
          const cookies = new Cookies();
          cookies.set("agent", dataset.data.token, { path: "/" });
          cookies.set("username", dataset.data.name, { path: "/" });
          showToast("Login successfully", "success");
          navigate("/agent/data");
        } else {
          showToast(dataset.err.msg || "Bad Authorization request", "error");
        }
      } else {
        showToast("Login failed,please try again", "error");
      }
    } catch (error) {
      console.log(error);
      showToast("Login Request Failed or network error", "error");
    } finally {
      setLoadingAnimation(false);
    }
  };

  return (
    <>
      <div className="login_wrapper">
        <AnimatedBackground />
        <div className="login_container" data-aos="fade-down">
          <div className="login_header">
            <div className="brand_logo">
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2L2 7V10C2 16 6 20.9 12 22C18 20.9 22 16 22 10V7L12 2Z" />
              </svg>
            </div>
            <h1>Agent CRM Login</h1>
            <p>Enter your credentials to access your account</p>
          </div>
          <form>
            <div className="input_row">
              <label labelFor="email">Email</label>
              <div className="input_wrapper">
                <input
                  onChange={(e) => {
                    setLogin({ ...getLogin, [e.target.name]: e.target.value });
                  }}
                  type="email"
                  name="email"
                  autoComplete="off"
                  placeholder=" "
                />
                <svg
                  className="input_icon"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                  <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                </svg>
              </div>
            </div>
            <div className="input_row">
              <label labelFor="password">Password</label>
              <div className="input_wrapper">
                <input
                  onChange={(e) => {
                    setLogin({ ...getLogin, [e.target.name]: e.target.value });
                  }}
                  type={password ? "text" : "password"}
                  name="password"
                  required
                  autoComplete="off"
                  placeholder=" "
                />
                <svg
                  className="input_icon"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                >
                  <path
                    fill-rule="evenodd"
                    d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                    clip-rule="evenodd"
                  />
                </svg>
                <span className="passwordtoggleicon" onClick={toggleIcon}>
                  {password ? <FaEye /> : <FaEyeSlash />}{" "}
                </span>
              </div>
            </div>
            <div className="warningmessage" id="warningmessage">
              Please contact administrator!
            </div>

            <div className="btncontainer">
              <button
                id="loginbutton"
                type="submit"
                onClick={(e) => {
                  e.preventDefault();
                  handleLogin();
                }}
              >
                {loadingAnimation ? (
                  <Loader loading={loadingAnimation} />
                ) : (
                  "Login"
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default AgentLogin;
